import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class TrendsBlockedChartsService extends BaseService {
  constructor() {
    super(constants.GET_AI_CONTENT_FILTER_CHARTS_UTILITY_DATA, 'TrendsBlockedChartsService');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackbv2').post(`/trends/count/blocked`, payload, { headers: enhancedHeaders });
    }
    // Default flow: aiadminv2 with automatic token handling
    return this.getClient('aiadminv2').post(`/trends/count/blocked`, payload, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('trendsBlockedCharts').setResponse(response.data);
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('trendsBlockedCharts').resetStoreValues();
  }
}
